let _pf = (valor) => {
    if (typeof valor === 'undefined' || valor == null) {
        return 0;
    }
    return parseFloat(valor)
}


let aplicar = (context) => {

    let valorAmostra = 0;
    let analise = context.analise;
    let precoRemetente = context.precoRemetente;
    let configuracao = context.configuracao;
    let valorTipo = 0
    let valores = {
        'valor_solo_quimica': 0,
        'valor_solo_fisica': 0,
        'valor_solo_extrato': 0,
        'valor_semente_germinacao': 0,
        'valor_semente_vigor': 0,
        'valor_tecido': 0,
        'valor_fertilizante': 0,
    }

    let precoRemetenteInformado = precoRemetente != null;

    if (analise.tipo.value === 'SOLO') {

        if(analise.id_coleta_app == undefined || analise.id_coleta_app == null) {
            if (analise.solo_quimica) {
                valorTipo = (precoRemetenteInformado && _pf(precoRemetente.valor_quimica) > 0 ? _pf(precoRemetente.valor_quimica) : _pf(configuracao.valor_quimica)) - _pf(precoRemetente.desconto_quimica)
                if (configuracao.desconto_quimica > 0 && (parseInt(analise.subsidio) || parseInt(analise.subsidio_sebrae)) && analise.solo_fisica) {
                    valorTipo = valorTipo - (valorTipo * (configuracao.desconto_quimica / 100))
                }
                valores.valor_solo_quimica += valorTipo
                valorAmostra += valorTipo;
            }

            if (analise.solo_fisica) {
                valorTipo = (precoRemetenteInformado && _pf(precoRemetente.valor_fisica) > 0 ? _pf(precoRemetente.valor_fisica) : _pf(configuracao.valor_fisica)) - _pf(precoRemetente.desconto_fisica)
                if (configuracao.desconto_fisica > 0 && (parseInt(analise.subsidio) || parseInt(analise.subsidio_sebrae)) && analise.solo_quimica) {
                    valorTipo = valorTipo - (valorTipo * (configuracao.desconto_fisica / 100))
                }
                valores.valor_solo_fisica += valorTipo
                valorAmostra += valorTipo;
            }

            if(analise.solo_fisica && analise.solo_quimica) {
                //usar a do cliente se for maior que zero
                if(Object.keys(precoRemetente).length != 0 && _pf(precoRemetente.valor_quimica_fisica) > 0) {
                    valorAmostra = _pf(precoRemetente.valor_quimica_fisica)
                }
                //usar a do sistema se for maior que zero e nao tiver a do cliente
                if(configuracao.valor_quimica_fisica > 0 && _pf(precoRemetente.valor_quimica_fisica) == 0) {
                    valorAmostra = _pf(configuracao.valor_quimica_fisica)
                }
                //caso nenhuma entre, ele usa o valor padrao da Q + F
            }
        } else {
            if(Object.keys(precoRemetente).length != 0 && _pf(precoRemetente.valor_analise_api) > 0) {
                valorAmostra = _pf(precoRemetente.valor_analise_api)
            } else {
                valorAmostra = _pf(configuracao.valor_analise_api)
            }
        }

        if (analise.solo_extrato_saturacao) {
            valorTipo = (precoRemetenteInformado && _pf(precoRemetente.valor_extrato_saturacao) > 0 ? _pf(precoRemetente.valor_extrato_saturacao) : _pf(configuracao.valor_extrato_saturacao)) - _pf(precoRemetente.desconto_extrato_saturacao)
            if (configuracao.desconto_extrato_saturacao > 0 && analise.solo_fisica && analise.solo_quimica) {
                valorTipo = valorTipo - (valorTipo * (configuracao.desconto_extrato_saturacao / 100))
            }
            valores.valor_solo_extrato += valorTipo
            valorAmostra += valorTipo;
        }

        if (analise.solo_metais_pesados) {
            valorAmostra += (precoRemetenteInformado && _pf(precoRemetente.valor_metais_pesados) > 0 ? _pf(precoRemetente.valor_metais_pesados) : _pf(configuracao.valor_metais_pesados)) - _pf(precoRemetente.desconto_metais_pesados);
        }

        if(analise.solo_quimica){
            if(analise.pacote_elementos_1) {
                valorAmostra += (Object.keys(precoRemetente).length != 0 && _pf(precoRemetente.valor_pacote_elementos_1) > 0) ? _pf(precoRemetente.valor_pacote_elementos_1) :  _pf(configuracao.pacote_elementos_1)
            } else {
                if(analise.analisa_ph_calc2)         valorAmostra += (Object.keys(precoRemetente).length != 0 && _pf(precoRemetente.valor_ph_calc2) > 0) ? _pf(precoRemetente.valor_ph_calc2) : _pf(configuracao.valor_ph_calc2);
                if(analise.analisa_fosforo_resina)   valorAmostra += (Object.keys(precoRemetente).length != 0 && _pf(precoRemetente.valor_fosforo_resina) > 0) ? _pf(precoRemetente.valor_fosforo_resina) : _pf(configuracao.valor_fosforo_resina);
                if(analise.analisa_ferro)            valorAmostra += (Object.keys(precoRemetente).length != 0 && _pf(precoRemetente.valor_ferro) > 0) ? _pf(precoRemetente.valor_ferro) : _pf(configuracao.valor_ferro);
                if(analise.analisa_condutividade)    valorAmostra += (Object.keys(precoRemetente).length != 0 && _pf(precoRemetente.valor_condutividade) > 0) ? _pf(precoRemetente.valor_condutividade) : _pf(configuracao.valor_condutividade);
                if(analise.analisa_nitrogenio_azoto) valorAmostra += (Object.keys(precoRemetente).length != 0 && _pf(precoRemetente.valor_nitrogenio_azoto) > 0) ? _pf(precoRemetente.valor_nitrogenio_azoto) : _pf(configuracao.valor_nitrogenio_azoto);
                if(analise.analisa_silicio)          valorAmostra += (Object.keys(precoRemetente).length != 0 && _pf(precoRemetente.valor_silicio) > 0) ? _pf(precoRemetente.valor_silicio) : _pf(configuracao.valor_silicio);
            }
        }
    }

    if (analise.tipo.value === 'SEMENTE') {
        if (analise.semente_germinacao) {
            valorTipo = (precoRemetenteInformado && _pf(precoRemetente.valor_germinacao) > 0 ? _pf(precoRemetente.valor_germinacao) : _pf(configuracao.valor_germinacao)) - _pf(precoRemetente.desconto_germinacao)
            valorAmostra += valorTipo;
            valores.valor_semente_germinacao += valorTipo
        }
        if (analise.semente_vigor) {
            valorTipo = (precoRemetenteInformado && _pf(precoRemetente.valor_vigor) > 0 ? _pf(precoRemetente.valor_vigor) : _pf(configuracao.valor_vigor)) - _pf(precoRemetente.desconto_vigor)
            valorAmostra += valorTipo;
            valores.valor_semente_vigor += valorTipo
        }
    }

    if (analise.tipo.value === 'TECIDO') {
        valorTipo = (precoRemetenteInformado && _pf(precoRemetente.valor_tecido_vegetal) > 0 ? _pf(precoRemetente.valor_tecido_vegetal) : _pf(configuracao.valor_tecido_vegetal)) - _pf(precoRemetente.desconto_tecido_vegetal)
        valorAmostra += valorTipo;
        valores.valor_tecido += valorTipo
    }

    if (analise.tipo.value === 'FERTILIZANTE') {
        valorTipo = (precoRemetenteInformado && _pf(precoRemetente.valor_fertilizante) > 0 ? _pf(precoRemetente.valor_fertilizante) : _pf(configuracao.valor_fertilizante)) - _pf(precoRemetente.desconto_fertilizante)
        valorAmostra += valorTipo;
        valores.valor_fertilizante += valorTipo
    }

    for (var [index, valor] of Object.entries(valores)) {
        context.$set(context.analise, index, valor)
    }
    return context.$set(context.analise, 'valor_amostra', valorAmostra)
}


export default {
    aplicar
}